<template>
  <section class="home-six">
    <div class="six-inner">
      <div class="six-left">
        <h2>{{ showInfo.title }}</h2>
        <div class="btn">
          <a @click="tagChange(-1)"
            ><img src="../../../assets/home/home-left.svg" alt=""
          /></a>
          <a @click="tagChange(1)"
            ><img src="../../../assets/home/home-right.svg" alt=""
          /></a>
        </div>
      </div>
      <div class="six-right">
        <div class="logo">
          <h2>{{ showInfo.brand }}</h2>
          <!-- <img :src="showInfo.imgUrl" alt=""> -->
        </div>
        <p>{{ showInfo.text }}</p>
        <h3>
          <span style="color: #2f5ad9">{{ showInfo.name }}</span
          >{{ showInfo.name2 }}
        </h3>
        <ul>
          <li
            v-for="item in sixRightList"
            :key="item.title"
            @click="showInfo = item"
            :class="{ action: item.title === showInfo.title }"
          ></li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeSix',
  data() {
    return {
      showInfo: {},
      sixRightList: [
        {
          brand: '悠然居',
          title: '促进您的全球扩张',
          // imgUrl: require('@/assets/eco/youranju.png'),
          text: '借助Xport平台的全球情报系统，「悠然居」精准洞察欧美市场对环保家居的强劲需求，优化产品设计并接入多平台销售渠道。通过Xport提供的头程物流与海外仓服务，仅用3个月便实现从传统出口到独立站+平台并行的跨境转型，月销突破50,000单，品牌成功登陆亚马逊美国前100畅销榜。',
          name: 'Xport智链全球, ',
          name2: '助力「悠然居」把中国“生活美学”带进全球千家万户。'
        },
        {
          brand: '极充科技',
          title: '加速您的全球收入',
          // imgUrl: require('@/assets/home/home-three-1_Hugo-boss-1.svg'),
          text: '「极充科技」专注于便携充电与数据传输产品，借助Xport平台的全球需求匹配与多平台智能分发能力，快速打开北美与中东市场。通过Xport接入TikTok Shop与Amazon多平台渠道，并结合AI选品与物流智能推荐方案，产品上架首月订单环比增长280%，3个月内实现跨境营收翻番。',
          name: 'Xport,',
          name2:
            '加速「极充科技」的全球收入增长，让一根充电线走进世界每一个用户的日常生活。'
        },
        {
          brand: '尾巴星球',
          title: '最大化您的全球增长',
          // imgUrl: require('@/assets/home/home-carel.svg'),
          text: '专注于智能宠物喂养设备的「尾巴星球」，通过Xport平台整合全球情报与渠道资源，精准锁定北美与欧洲养宠热潮。借助平台提供的AI选品建议、定价优化和FBA中转服务，「尾巴星球」在6个月内实现从中国出厂到欧美电商平台稳定铺货，品牌销售覆盖12国，月营收增长超过350%。',
          name: 'Xport,',
          name2: ' 助力「尾巴星球」最大化全球增长，让智能养宠从中国走向世界。'
        },
        {
          brand: '肌本研',
          title: '提高您的全球转化率',
          // imgUrl: require('@/assets/home/home-NeverFullyDressed.svg'),
          text: '「肌本研」专注于敏感肌护理，通过Xport平台获取全球用户画像与趋势情报，针对欧美用户偏好优化产品描述、视觉素材及营销语境。结合Xport智能分发与A/B测试功能，平台帮助其在多语种站点提升页面转化效率，单品转化率从1.8%提升至4.6%，实现欧洲站点月销增长3倍。',
          name: 'Xport,',
          name2:
            ' 助力「肌本研」精准打动全球消费者，让每一份美丽，都更值得信赖与转化。'
        },
        {
          brand: '峰野探索',
          title: '获得全球销售方面的专家指导',
          // imgUrl: require('@/assets/home/home-anaLuisa.svg'),
          text: '起初专注于国内线下批发的「峰野探索」，在转型跨境电商过程中，通过Xport平台获得了来自全球销售顾问的深度指导。平台专家帮助其精准定位欧美露营市场，梳理品类策略、制定分阶段定价机制，并指导其完成多平台同步布局与推广。上线首季度，热销帐篷与户外灯具类产品销量即突破10万件，销售额同比增长420%。',
          name: 'Xport全球专家团队,',
          name2:
            ' 助力「峰野探索」从内贸走向世界，让户外热销不止于山野，更遍布全球市场。'
        },
        {
          brand: '小象智护',
          title: '利用全球需求',
          // imgUrl: require('@/assets/home/home-eyderwear.svg'),
          text: '「小象智护」聚焦婴儿健康护理与喂养用品，借助Xport平台的全球需求洞察系统，精准识别拉美和中东新兴市场对高品质婴童产品的快速增长需求。平台帮助其优化SKU组合，并连接本地热销渠道与母婴垂直平台，仅4个月便打入5个国家主流电商平台，实现首年销售增长超300%，多款产品跻身当地Top Seller榜单。',
          name: 'Xport,',
          name2:
            ' 挖掘全球真实需求，助力「小象智护」抓住跨境蓝海市场，把温柔与守护带向世界每一个家庭。'
        }
      ]
    }
  },
  mounted() {
    this.showInfo = this.sixRightList[0]
  },
  methods: {
    tagChange(num) {
      const sixRightListLength = this.sixRightList.length
      const itemIndex = this.sixRightList.findIndex(
        item => item.title === this.showInfo.title
      )
      if (num === 1) {
        const newIndex = itemIndex + num
        this.showInfo =
          this.sixRightList[newIndex >= sixRightListLength ? 0 : newIndex]
      } else {
        const newIndex = itemIndex + num
        this.showInfo =
          this.sixRightList[newIndex < 0 ? sixRightListLength - 1 : newIndex]
      }
    }
  }
}
</script>

<style scoped lang="less">
.home-six {
  background-image: linear-gradient(90deg, #f5f5f6 50%, #fff 50%);
  .six-inner {
    width: 1140px;
    height: 470px;
    margin: 0 auto;
    display: flex;
    .six-left {
      padding: 60px;
      flex: 1;
      display: flex;
      flex-direction: column;
      h2 {
        margin: auto;
        font-size: 48px;
      }
      .btn {
        justify-self: end;
        display: flex;
        gap: 20px;
      }
    }
    .six-right {
      flex: 1;
      padding: 30px 70px;
      line-height: 1.7;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .logo {
        width: 400px;
        height: 120px;
        display: flex;
        align-items: center;
        font-size: 32px;
        h2 {
          font-size: 30px;
        }
        img {
          max-height: 100%;
          max-width: 100%;
        }
      }
      p {
        margin: 20px 0;
      }
      ul {
        margin-top: auto;
        max-width: 100%;
        display: flex;
        gap: 5px;
        li {
          flex: 1;
          height: 10px;
          background-color: #ededed;
          cursor: pointer;
        }
        .action {
          background-color: #2f5ad9;
        }
      }
    }
  }
}
</style>
